import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

if (environment.production) {
  enableProdMode();
}

if ((environment as any)?.faro?.url) {
  try {
    initializeFaro({
      url: (environment as any).faro.url,
      app: {
        name: (environment as any).faro.appName,
        version: (environment as any).faro.appVersion,
      },
      instrumentations: [
        ...getWebInstrumentations({ captureConsole: true }),
        new TracingInstrumentation({})
      ]
    });
  } catch (err) {
    console.error('Faro initialization failed:', err);
  }
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
